import { z } from 'zod';

export const zodCompanyAliasAddressesSearchParametersSchema = z.object({
  page: z.coerce.number().nonnegative().optional().prefault(0).catch(0),
  searchString: z.string().optional().catch(''),
});

export const zodCompanySearchParametersSchema = z.looseObject({
  aliasAddressId: z.uuid().optional().catch(undefined),
  tab: z
    .enum([
      'aiSettings',
      'aliasAddresses',
      'apiKeys',
      'deliveryNoteEmails',
      'general',
      'invoiceEmails',
      'invoiceSettings',
      'watermarkPosition',
    ])
    .optional()
    .catch('general'),
  view: z.enum(['create', 'edit', 'view']).optional().catch(undefined),
});

export const zodCompaniesAdminQueryParams = z.object({
  isActive: z.boolean().optional().prefault(true).catch(true),
  search: z.string().optional().catch(undefined),
});
